import template from "./create-quote-version-modal.html";

const CreateQuoteVersionModalComponent = {
  bindings: {
    resolve: "<",
    close: "&",
    dismiss: "&",
  },
  template: template,
  controller: class ModalController {
    /* @ngInject */
    constructor($rootScope, $sce, SecurityManager, moment) {
      this.$rootScope = $rootScope;
      this.$sce = $sce;
      this.SecurityManager = SecurityManager;
      this.moment = moment;
    }

    $onInit() {
      this.quote = this.resolve.quote;
      this.shared = this.quote.shared;
      this.date = this.moment()
        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        .toDate();

      this.expirationDate = this.moment()
        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        .add(this.$rootScope.organization.settings.expirationPeriod, "days")
        .toDate();
    }

    async toogleShared() {
      if (this.shared) await this.quote.share();
      else await this.quote.unshare();
    }

    getShowQuoteUrl() {
      if (!this.$rootScope.organization)
        throw new Error("Organization was not loaded yet.");
      return this.$sce.trustAsResourceUrl(
        `${this.$rootScope.organization.getDomainUrl()}/show/${
          this.quote.token
        }`
      );
    }

    save() {
      if (this.form.$valid) {
        this.close({
          $value: { date: this.date, expirationDate: this.expirationDate },
        });
      }
    }

    cancel() {
      this.dismiss({ $value: "cancel" });
    }
  },
};

export default CreateQuoteVersionModalComponent;
